import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

function Footer() {
  return (
    <footer style={{ width: '100%', background: 'var(--bnb-navy)', color: 'rgba(255,255,255,0.7)', marginTop: '2rem', padding: '1.5rem 0', fontSize: '0.8rem' }}>
      <Container fluid className='px-4'>
        <Row className='align-items-center'>
          <Col md={6} className='text-center text-md-start mb-2 mb-md-0'>
            <span style={{ fontWeight: '900', color: '#fff', letterSpacing: '-0.02em' }}>BNB</span>
            <span style={{ fontWeight: '900', color: 'var(--bnb-gold)', marginLeft: '3px' }}>GOLF</span>
            <span style={{ marginLeft: '12px' }}>
              &copy; {new Date().getFullYear()} BNB Golf Club. All rights reserved.
            </span>
          </Col>
          <Col md={6} className='text-center text-md-end' style={{ color: 'rgba(255,255,255,0.45)' }}>
            Built with&nbsp;<i className="fa-solid fa-heart" style={{ color: 'var(--bnb-gold)', fontSize: '0.7rem' }}></i>&nbsp;for the game & heckling
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
